<template>
  <div class="w-full" data-testid="profile-popup">
    <!-- Title Section -->
    <div class="mb-5 self-stretch relative w-full flex items-center justify-center gap-2" data-testid="profile-title-section">
      <header class="absolute left-0 top-1/2 -translate-y-1/2" v-show="backButtonShown">
        <a href="javascript:;" @click="back" data-testid="profile-back-button">
          <img src="@/assets/icons/arrow-left.svg" class="w-[25px]" />
        </a>
      </header>
        <div class="self-stretch flex flex-col text-center items-center gap-1">
            <div class="self-stretch text-center text-white text-2xl font-bold font-['Inter'] leading-[30px]" data-testid="profile-header-title">
            {{ $t('profile_header') !== 'profile_header' ? $t('profile_header') : 'Profile' }}
            </div>
        </div>
    </div>
    
    <div v-if="selectorExpanded" data-testid="language-selector-expanded">
      <language-picker v-show="selectorExpanded" :initial="profile.language" :close-on-select="false" :open="openLanguageSelector" @back="onLanguageBack" @globalback="saveProfile" @select="selectLanguage" data-testid="profile-language-picker"></language-picker>
    </div>
    <form v-else action="#" method="POST" @submit.prevent="saveProfile" data-testid="profile-form">
        <div class="mb-3 max-[800px]:mb-[18px]" data-testid="profile-name-section">
            <label class="block text-white/90 text-base leading-[1.18rem] mb-2 pl-[10px]" for="#profile_name" data-testid="profile-name-label">{{ $t('profile_name') }}</label>
            <input type="text" required name="name" v-model="profile.name" class="border-2 border-[#292F36] rounded-[10px] bg-transparent text-white font-normal text-base leading-[1.18rem] h-[44px] w-full px-[10px] outline-none focus:border-[#6CBFFF]" placeholder="" id="profile_name" data-testid="profile-name-input">
        </div>
        
        <div class="mb-3 max-[800px]:mb-[18px]" data-testid="profile-language-section">
         <div class="block text-white/90 text-base leading-[1.18rem] mb-2 pl-[10px]" data-testid="profile-language-label">{{ $t('profile_language') }}</div>
          <div class=" flex items-center border-2 border-[#292F36] rounded-[10px] bg-transparent text-white font-normal text-base leading-[1.18rem] h-[44px] w-full px-[10px] outline-none focus:border-[#6CBFFF] cursor-pointer" @click="expandSelector" data-testid="profile-language-selector">
            <span class="w-[20px] h-[20px] flex rounded-full" data-testid="profile-language-flag"><img class="rounded-full w-[20px] h-[20px]" :src="'/data/flags/' + profile.language + '.png'"/></span>
            <span class="font-inter font-normal text-[1rem] leading-[1.18rem] text-white ml-[10px]" data-testid="profile-language-name">{{ selectedLangName }}</span>
          </div>
        </div>

        <!-- Voice tone selection -->
        <div class ="mb-3" data-testid="profile-voice-tone-section">
            <div class="font-medium text-white" data-testid="profile-voice-tone-title">{{ $t('session_setup_voice_tone') !== 'session_setup_voice_tone' ? $t('session_setup_voice_tone') : 'Your voice tone' }}</div>
            <div class="text-sm text-neutral-400" data-testid="profile-voice-tone-description">{{ $t('session_setup_voice_tone_desc') !== 'session_setup_voice_tone_desc' ? $t('session_setup_voice_tone_desc') : 'Select the tone you want particpants to hear when captions are read out loud' }}</div>
        </div>
        
        <div class="flex bg-[#282F35] rounded-xl h-[45px] mb-6" data-testid="profile-voice-selection">
            <label class="justify-center cursor-pointer w-1/2 flex items-center m-0 font-normal pl-0" id="voice_male" data-testid="profile-voice-male-label">
                <input type="radio" v-model="profile.voice" name="voice" value="male" class="hidden peer" data-testid="profile-voice-male-input"/>
                <span class="peer-checked:bg-[#374D60] flex justify-center items-center h-full w-full rounded-xl"
                        :class="profile.voice === 'male' ? 'text-[#6CBFFF]' : 'text-neutral-400'" data-testid="profile-voice-male-option">
                    <svg class="mr-[10px] align-middle" width="18" height="18" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="profile.voice==='male' ? '#6CBFFF' : '#C2C2C2'" d="M10.5 4.278C10.5 3.51572 10.4246 2.92207 10.2226 2.5332C10.1297 2.35444 10.0164 2.23292 9.87691 2.15104C9.73516 2.06786 9.52235 2 9.19201 2C9.0262 1.99993 8.86722 1.93817 8.7454 1.82812L8.70243 1.78516C8.70398 1.78683 8.70496 1.78832 8.70568 1.78906C8.70522 1.78861 8.70454 1.78788 8.70373 1.78711C8.698 1.78165 8.68366 1.76892 8.66076 1.75065C8.61474 1.71394 8.53315 1.65552 8.41271 1.5944C8.17506 1.47385 7.77044 1.33333 7.16141 1.33333C6.28311 1.33335 5.64308 1.59463 5.21935 2.03646C4.79252 2.48153 4.49995 3.19885 4.49995 4.278C4.49997 5.39597 4.68963 6.16207 4.98237 6.73893C5.27454 7.31463 5.69549 7.75354 6.24409 8.18294C6.40554 8.3093 6.49995 8.50332 6.49995 8.70833V10C6.49995 10.2942 6.3071 10.5539 6.02534 10.6387L3.55008 11.3822L3.55073 11.3828C2.91091 11.5787 2.4239 12.0648 2.21415 12.6667H12.7858C12.576 12.0648 12.089 11.5787 11.4492 11.3828L8.97456 10.6387C8.6928 10.5539 8.49995 10.2942 8.49995 10V8.70833C8.49995 8.50332 8.59437 8.3093 8.75581 8.18294C9.30441 7.75354 9.72536 7.31463 10.0175 6.73893C10.3103 6.16207 10.4999 5.39597 10.5 4.278ZM11.8333 4.278C11.8333 5.54854 11.6167 6.53306 11.2063 7.3418C10.8511 8.04175 10.3695 8.57066 9.83329 9.02409V9.50456L11.8359 10.1068L11.8391 10.1081C12.9896 10.4602 13.8462 11.3839 14.1308 12.5104C14.3571 13.4076 13.5687 13.9999 12.8958 14H2.10412C1.43131 13.9999 0.643236 13.4078 0.869744 12.5104C1.15429 11.3839 2.01028 10.4602 3.16076 10.1081L3.16402 10.1068L5.16662 9.50456V9.02409C4.6304 8.57066 4.14878 8.04176 3.79357 7.3418C3.38322 6.53306 3.16663 5.54854 3.16662 4.278C3.16662 2.96391 3.52611 1.8755 4.25711 1.11328C4.99119 0.347966 6.01483 1.54301e-05 7.16141 0C7.98616 0 8.59694 0.192844 9.01623 0.405599C9.20022 0.498962 9.34429 0.595106 9.45178 0.677083C9.86232 0.707788 10.2312 0.812947 10.552 1.0013C10.9414 1.2299 11.2164 1.55455 11.4056 1.91862C11.7675 2.61539 11.8333 3.49403 11.8333 4.278Z"/>
                    </svg>
                    {{ $t('enum_voicegender_male') }}
                </span>
            </label>
            <label class="justify-center cursor-pointer w-1/2 flex items-center m-0 font-normal pl-0" id="voice_female" data-testid="profile-voice-female-label">
                <input type="radio" v-model="profile.voice" name="voice" value="female" class="hidden peer" data-testid="profile-voice-female-input"/>
                <span class="peer-checked:bg-[#374D60] flex justify-center items-center h-full w-full rounded-xl"
                        :class="profile.voice === 'female' ? 'text-[#6CBFFF]' : 'text-neutral-400'" data-testid="profile-voice-female-option">
                    <svg class="mr-[10px] align-middle" width="18" height="18" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="profile.voice==='female' ? '#6CBFFF' : '#C2C2C2'" d="M3.5 4.07488C3.50003 2.98743 3.75409 2.11223 4.20247 1.44728C4.65246 0.780055 5.27113 0.365308 5.92448 0.15952C6.57102 -0.0440616 7.24992 -0.0433244 7.84635 0.108088C8.30344 0.224126 8.74526 0.438223 9.09049 0.751317C9.5281 0.72135 9.93061 0.776728 10.2839 0.950535C10.7474 1.17863 11.0314 1.56165 11.2012 1.97918C11.365 2.38231 11.4337 2.84307 11.4668 3.29363C11.5002 3.74804 11.5 4.24541 11.5 4.73113C11.5 6.19625 11.9179 7.36157 12.0944 7.709C12.1805 7.87856 12.1898 8.07685 12.1204 8.25392C12.051 8.431 11.9095 8.57013 11.7311 8.63608C11.1534 8.84964 10.5144 9.01776 9.83333 9.13608V9.50392L11.8359 10.1068L11.8392 10.1074C12.9897 10.4595 13.8462 11.3833 14.1309 12.5098C14.357 13.4069 13.5687 14 12.8958 14H2.10417C1.4313 14 0.643121 13.4072 0.869791 12.5098C1.15442 11.3834 2.01033 10.4595 3.16081 10.1074L3.16406 10.1068L5.16667 9.50392V9.13608C4.48557 9.01776 3.8466 8.84964 3.26888 8.63608C3.09048 8.57013 2.94896 8.431 2.87956 8.25392C2.81021 8.07685 2.81952 7.87856 2.9056 7.709C3.17811 7.17276 3.5 6.29954 3.5 4.07488ZM4.83333 4.07488C4.83333 5.80483 4.64823 6.85533 4.39518 7.59832C4.86356 7.72907 5.37418 7.83288 5.91732 7.90171C6.25031 7.94397 6.49991 8.22751 6.5 8.56316V10C6.5 10.2942 6.30715 10.5539 6.02539 10.6387L3.55013 11.3822L3.55078 11.3828C2.91096 11.5788 2.42394 12.0648 2.21419 12.6667H12.7858C12.576 12.0648 12.089 11.5788 11.4492 11.3828L8.97461 10.6387C8.69285 10.5539 8.5 10.2942 8.5 10V8.56316C8.50009 8.22751 8.74969 7.94397 9.08268 7.90171C9.63112 7.83221 10.1464 7.72698 10.6185 7.59442C10.3915 6.90488 10.1667 5.89235 10.1667 4.73113C10.1667 4.23308 10.1665 3.78748 10.1374 3.39129C10.108 2.9912 10.0516 2.69296 9.96549 2.48113C9.88525 2.28385 9.7942 2.19516 9.69531 2.1465C9.58223 2.09088 9.3615 2.03992 8.94141 2.10874C8.69827 2.14859 8.45282 2.05135 8.30338 1.85548C8.16743 1.67715 7.89796 1.4968 7.51823 1.40041C7.14603 1.30593 6.72054 1.3067 6.32552 1.431C5.93744 1.5532 5.57661 1.79438 5.30794 2.19272C5.03762 2.59361 4.83337 3.19475 4.83333 4.07488Z" fill-opacity="0.55"/>
                    </svg>
                    {{ $t('enum_voicegender_female') }}
                </span>
            </label>
        </div>


        <div>
        <a href="javascript:;" class="flex justify-center items-center mb-6" @click="changePassword" data-testid="profile-change-password-link">
            <b class="text-[1rem] leading-[1.5rem] text-[#6CBFFF] font-normal capitalize text-center underline">{{ $t('profile_change_password') }}</b>
        </a>
        </div>
        <div class="w-full mb-5" data-testid="profile-save-section">
          <button
              type="submit"
              name="profile_submit"
              id="profile_submit"
              class="w-full h-[50px] px-[30px] bg-[#6CBFFF] hover:bg-opacity-30 rounded-xl shadow-[0px_5.01333px_5.01333px_rgba(0,0,0,0.25)] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
              value="Save"
              data-testid="profile-save-button"
              > 
              <div class="text-black text-base font-medium font-['Inter'] leading-normal">
              {{ $t('common_save') || 'Save' }}
              </div>
          </button>
        </div>

        <a href="javascript:;" class="text-[#FF6566] flex flex-1 justify-center items-center text-center no-underline mb-3" @click="deactivate" data-testid="profile-delete-account-link">
          <img src="@/assets/icons/trash.svg" alt="Delete Account" class="max-w-[20px] mr-[10px]">
          {{ $t('profile_delete_account')}}
        </a>
    </form>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import LanguagePicker from '../session/LanguagePicker.vue';
import emitter from "@/services/emitter.service";
import { Constants } from '@/cfg/constants';

export default {
  name: 'ProfilePopup',
  props: {
    openLanguageSelector: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      profile: '',
      backButtonShown: true,
      selectorExpanded: false
    }
  },
  components: {
    LanguagePicker
  },
  methods: {
    async formRequest() {
      if (!this.validate()) return

      try {
        const updatedProfile = {
          ...this.profile,
          token: this.token
        }

        await this.$store.dispatch("auth/update", updatedProfile)

        const refreshedAuthUser = await this.$forumAuth.refreshSession()

        this.profile = {
          ...updatedProfile,
          email: updatedProfile.email || refreshedAuthUser?.email
        }

        this.updateSuccess = true
        this.$toast.success('common_changes_saved')
        this.selfClose()
      } catch (error) {
        this.$toast.error(error?.response?.data?.error || 'common_error')
      }
    },
    validate() {
      // for now we are just validation passwords match
      // TODO other validation we need
      return true;
    },
    deactivate() {
      const warning = process.env.VUE_APP_REGION === "uk" ? 'profile_delete_account_warning_uk' : 'profile_delete_account_warning';
      this.$dialog.confirm(warning, { danger: true }).then((confirmed) => {
        if (confirmed) {
          if (process.env.VUE_APP_REGION === "uk") {
            this.$store.dispatch("auth/markForDelete", this.user.email);
          } else {
            this.$store.dispatch("auth/delete", this.user);
          }
          this.selfClose();
          this.$toast.success('common_delete_account_success');
        }
      })
    },
    saveProfile() {
      this.formRequest();
    },
    selectLanguage(langCode) {
      this.backButtonShown = true;
      this.profile.language = langCode;
      if (this.openLanguageSelector) {
        this.saveProfile();
      }
    },
    expandSelector() {
      this.selectorExpanded = true;
    },
    back() {
      if (this.selectorExpanded){
        this.selectorExpanded = false;
      }
      else{
        this.selfClose();
        emitter.emit('open-account-popup');
      }
    },
    onLanguageBack() {
      this.backButtonShown = true;
    },
    changePassword() {
      this.selfClose();
      emitter.emit('open-change-password-modal');
    },
    selfClose() {
      this.$emitter.emit('modalClose');
    },
  },
  computed: {
     ...mapState('auth', ['token', 'authorized']),
      ...mapState('nonpersist', ['user']),
      ...mapState('lang', ['languages']),
      selectedLangName() {
        if (!this.languages || !this.profile.language) return this.profile.language;
        const langObj = this.languages.find(lang => lang.code === this.profile.language)
          || this.languages.flatMap(lang => lang.dialects || []).find(d => d.code === this.profile.language);
        return langObj ? (langObj.native_name || langObj.name) : this.profile.language;
      }
  },
  mounted() {
    const authUser = this.$forumAuth.getUser()

    this.profile = {
      ...(authUser || {}),
      ...(this.user || {})
    }

    this.profile.name = this.profile.name || authUser?.name || ''
    this.profile.email = this.profile.email || authUser?.email || ''
    this.profile.language = this.profile.language || Constants.DEFAULT_LANGUAGE
  }
}
</script>

